<!-- <iframe src="https://culturalgo.com/modules/cultureaudit7/controllers/verificacion.php?bd_ca=cultureaudit_ca_beta_pruebas&empleadoId=2464&empresaNombre=Turkey%2005&idiomaCA=2&administrador=" width="" height=""></iframe> -->
<ng-container *ngIf="mailUsuario">
  <iframe [src]="urlSafe" width="" height=""></iframe>
</ng-container>
